<p-table #dt [value]="searchResults" [columns]="cols" responsiveLayout="scroll" [rows]="90" [paginator]="true"
    [rowsPerPageOptions]="[30,60,90]" [showCurrentPageReport]="true" (onPage)="onPageChanged($event)" scrollHeight="800px"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [(selection)]="selectedResults"
    selectionMode="multiple" [rowHover]="true" dataKey="domain">
    <ng-template pTemplate="emptymessage">
        <p class="flex align-items-center justify-content-center p-3 text-lg font-medium no-results-message">No Results Available</p>
    </ng-template>
    <ng-template pTemplate="caption">
        <ng-content></ng-content>
    </ng-template>
    <ng-template pTemplate="header">
        <tr class="sticky-header">
            <th pSortableColumn="domain" pTooltip="{{'components.referringDomainsResults.domainTooltip' | translate}}">{{'components.referringDomainsResults.domainHeader' | translate}}</th>
            <th pSortableColumn="rank" pTooltip="{{'components.referringDomainsResults.rankHeaderTooltip' | translate}}">{{'components.referringDomainsResults.rankHeader' | translate}}</th>
            <th pSortableColumn="referringDomains" pTooltip="{{'components.referringDomainsResults.referringDomainsHeaderTooltip' | translate}}">{{'components.referringDomainsResults.referringDomainsHeader' | translate}}</th>
            <th pSortableColumn="backlinks" pTooltip="{{'components.referringDomainsResults.backlinksHeaderTooltip' | translate}}">{{'components.referringDomainsResults.backlinksHeader' | translate}}</th>
            <th pSortableColumn="brokenBacklinks" pTooltip="{{'components.referringDomainsResults.brokenBacklinksHeaderTooltip' | translate}}">{{'components.referringDomainsResults.brokenBacklinksHeader' | translate}}</th>
            <th pSortableColumn="brokenPages" pTooltip="{{'components.referringDomainsResults.brokenPagesHeaderTooltip' | translate}}">{{'components.referringDomainsResults.brokenPagesHeader' | translate}}</th>
            <th pSortableColumn="firstSeen" pTooltip="{{'components.referringDomainsResults.firstSeenHeaderTooltip' | translate}}">{{'components.referringDomainsResults.firstSeenHeader' | translate}}</th>
            <th></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-result let-expanded="expanded">
        <tr>
            <td style="width:20%; min-width:10rem;">
                <a target="_blank" [href]="'https://'+result?.domain" [pTooltip]="result?.domain">{{result?.domain | truncate: 50}}</a>
            </td>
            <td style="width:14%; min-width:10rem;">
                {{result?.rank | number:'1.0':'en-US'}}
            </td>
            <td style="width:14%; min-width:10rem;">
                {{result?.referringDomains | number:'1.0':'en-US'}}
            </td>
            <td style="width:7%; min-width:10rem;">
                <span class="text-purple-600 cursor-pointer" (click)="onBacklinkClicked(result)">{{result?.backlinks | number:'1.0':'en-US'}}</span>
                <!-- <button class="p-button-text" style="width:50%;" pButton type="button" [label]="result?.backlinks" [icon]="result?.openBacklinksDropDown ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                iconPos="right" [pRowToggler]="result" (click)="onBacklinkClicked(result)"></button> -->
            </td>
            <td style="width:14%; min-width:10rem;">
                {{result?.brokenBacklinks | number:'1.0':'en-US'}}
            </td>
            <td style="width:14%; min-width:10rem;">
                {{result?.brokenPages | number:'1.0':'en-US'}}
            </td>
            <td style="width:15%; min-width:10rem;">
                {{result?.firstSeen | date:'short'}}
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-data>
        <tr>
            <td colspan="7">
                <div class="p-3">
                    <gig-backlinks-results #searchResultsTable [searchResults]="data.referringDomainsBacklinks?.items">
                    </gig-backlinks-results>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
